import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  ViewChild
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  adobeClickEventAnalyticsMocks,
  ANALYTICS_EVENTS,
  HEADER_MENU,
  Irop,
  IropService,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { of, Subject, Subscription } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { DataLayer } from '../../common/datalayer/datalayer';
import { DateSelectionComponent } from '../../common/date-selection/date-selection.component';
import {
  CustomValidator,
  validateFromAndToAirports
} from '../../common/error-handler/custom-validator';
import { ErrorHandlerDirective } from '../../common/error-handler/error-handler.directive';
import { FloatingLabelDirective } from '../../common/floatinglabel-directive/floatinglabel.directive';
import { ApplicationConfig } from '../../config/config';
import { ContentFlightStatus } from '../../model/content/contentflightstatus.model';
import { ContentHeaderFooter } from '../../model/content/contentheaderfooter.model';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { AdobeDataLayerService } from '../../services/adobe-data-layer/adobe-data-layer';
import { FormStoreDirective } from '../../store/directive/form-store.directive';

@Component({
  selector: 'ngc-flight-status',
  templateUrl: 'navigation-flight-status.component.html'
})
export class NavigationFlightStatusComponent
  implements AfterViewInit, OnInit, OnDestroy
{
  @ViewChild(ErrorHandlerDirective) errorHandler: ErrorHandlerDirective;
  @ViewChild('FlightNumberValue') FlightNumberValue: FloatingLabelDirective;
  @ViewChild('formStoreDir') formStoreDir: FormStoreDirective;
  @ViewChild(DateSelectionComponent) dateSelComp: DateSelectionComponent;
  isSubmitted: boolean;
  isSearchByFlightNumber: boolean;
  public fromAirport: string;
  public toAirport: string;
  public fromCity: string;
  public toCity: string;
  public flightSubmitUrl: string;
  public flightStatusSubmitUrl: string;
  public flightScheduleSubmitUrl: string;
  public contentFlightStatus: ContentFlightStatus;
  public flightStatusWidgetForm: UntypedFormGroup;
  public searchOptionValue: string;
  public flightNumber: string;
  public formUrl: string;
  public flightDate: string;
  public fieldToFocus = 'departcitylink';
  public showErrorFlightNumber = false;
  defaultSearchDate = '';
  contentServiceHeaderFooterSubscribe: Subscription;
  public flightSearchStartDate: boolean;
  @Input() widgetOnTop = false;
  @Output() errorPresent: EventEmitter<boolean> = new EventEmitter<boolean>();
  private unsubscribe: Subject<void> = new Subject();
  iropSubscribe: Subscription;

  constructor(
    private cdf: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    private formBuilder: UntypedFormBuilder,
    private datalayer: DataLayer,
    @Inject(PLATFORM_ID) private platformId: Object,
    private config: ApplicationConfig,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private loggingService: LoggingService,
    private iropService: IropService,
    private adobeDataLayer: AdobeDataLayerService
  ) {
    const content = new ContentHeaderFooter();
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    if (isPlatformBrowser(this.platformId)) {
      if (document.body.scrollWidth < 1025 && document.body.scrollWidth > 767) {
        const dateViewSection = <HTMLElement>(
          document.querySelector(
            'div.travelDateSelectionView button.closeButton'
          )
        );
        if (dateViewSection && dateViewSection !== undefined) {
          dateViewSection.dispatchEvent(new Event('click'));
        }
      }
    }
  }

  ngOnInit() {
    // Use the below flag to switch on Features between DL and VS Flow
    this.flightSearchStartDate =
      this.config.get('APP_FLIGHT_SEARCH_DATE') &&
      this.config.get('APP_FLIGHT_SEARCH_DATE').toString() === 'true'
        ? true
        : false;
    this.flightStatusWidgetForm = this.formBuilder.group(
      {
        departureDate: ['', Validators.required],
        flightNumber: [
          '',
          [Validators.maxLength(9), Validators.pattern('^[0-9]*$')]
        ],
        airports: this.formBuilder.group(
          {
            fromAirport: [this.fromAirport, Validators.pattern('^[a-zA-Z]+$')],
            toAirport: [this.toAirport, Validators.pattern('^[a-zA-Z]+$')]
          },
          { validator: validateFromAndToAirports('fromAirport', 'toAirport') }
        )
      },
      { validator: CustomValidator.eitherFlightNumberOrAirportsValidator }
    );

    const formValueChange = this.formStoreDir?.syncFromStoreComplete.subscribe(
      () => {
        const formValue = this.formStoreDir.formValueRef;
        if (formValue) {
          this.fromAirport =
            formValue['airports'] &&
            formValue['airports'].fromAirport &&
            this.fromAirport !== formValue['airports'].fromAirport
              ? formValue['airports'].fromAirport
              : '';
          this.toAirport =
            formValue['airports'] &&
            formValue['airports'].toAirport &&
            this.fromAirport !== formValue['airports'].toAirport
              ? formValue['airports'].toAirport
              : '';
          this.defaultSearchDate = formValue['departureDate']
            ? formValue['departureDate']
            : '';
          formValueChange.unsubscribe();
        }
      },
      (err) => {
        this.loggingService.log('Caught Error: ' + err);
      }
    );

    if (this.contentService.contentHeaderFooter) {
      this.contentServiceHeaderFooterSubscribe =
        this.contentService.contentHeaderFooter
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (data) => {
              if (data) {
                this.contentFlightStatus =
                  data.header.primaryNavigations.get('flightstatus').details;
                this.flightSubmitUrl = this.contentFlightStatus.submitUrl;
                this.flightStatusSubmitUrl =
                  this.contentFlightStatus.flightStatusSubmitUrl;
                this.flightScheduleSubmitUrl =
                  this.contentFlightStatus.flightScheduleSubmitUrl;
                //this.cdf.detectChanges();
              }
            },
            (err) => {
              this.loggingService.log('Caught Error: ' + err);
            }
          );
    }
  }

  numberOnly(event) {
    if (event.target.type === 'number') {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }
  }

  ngAfterViewInit() {
    const floatingLabelData = this.elementRef.nativeElement.querySelector(
      'label[for="flightNo"]'
    );
    this.renderer.setAttribute(floatingLabelData, 'aria-hidden', 'false');
  }

  swapCity() {
    const from = this.fromAirport;
    const to = this.toAirport;
    this.fromAirport = to;
    this.toAirport = from;
    if (to.toLowerCase() !== 'to') {
      this.markAsTouchedFrom();
    }
    if (from.toLowerCase() !== 'from') {
      this.markAsTouchedTo();
    }
  }

  inputFocus(event) {}

  onFlightnumberChange() {
    const fNo = this.flightStatusWidgetForm.controls.flightNumber.value;
    if (fNo && fNo.length > 0) {
      this.isSearchByFlightNumber = true;
      this.fromAirport = '';
      this.toAirport = '';
      (
        this.flightStatusWidgetForm.controls.airports as UntypedFormGroup
      ).controls.toAirport.setValue(this.toAirport);
      (
        this.flightStatusWidgetForm.controls.airports as UntypedFormGroup
      ).controls.toAirport.markAsTouched({ onlySelf: true });
      (
        this.flightStatusWidgetForm.controls.airports as UntypedFormGroup
      ).controls.fromAirport.setValue(this.fromAirport);
      (
        this.flightStatusWidgetForm.controls.airports as UntypedFormGroup
      ).controls.fromAirport.markAsTouched({ onlySelf: true });
    } else {
      this.isSearchByFlightNumber = false;
    }
  }

  markAsTouchedTo() {
    (
      this.flightStatusWidgetForm.controls.airports as UntypedFormGroup
    ).controls.toAirport.setValue(this.toAirport);
    (
      this.flightStatusWidgetForm.controls.airports as UntypedFormGroup
    ).controls.toAirport.markAsTouched({ onlySelf: true });
    this.flightStatusWidgetForm.controls.airports.markAsTouched({
      onlySelf: true
    });
    const fNo = this.flightStatusWidgetForm.controls.flightNumber.value;
    if (fNo && fNo.length > 0) {
      this.flightStatusWidgetForm.controls.flightNumber.setValue('');
      this.FlightNumberValue.hideFloatingLabel();
    }
    if (this.findDateDifference()) {
      this.resetCalendar();
    }
    this.isSearchByFlightNumber = false;
  }

  markAsTouchedFrom() {
    (
      this.flightStatusWidgetForm.controls.airports as UntypedFormGroup
    ).controls.fromAirport.setValue(this.fromAirport);
    (
      this.flightStatusWidgetForm.controls.airports as UntypedFormGroup
    ).controls.fromAirport.markAsTouched({ onlySelf: true });
    this.flightStatusWidgetForm.controls.airports.markAsTouched({
      onlySelf: true
    });
    const fNo = this.flightStatusWidgetForm.controls.flightNumber.value;
    if (fNo && fNo.length > 0) {
      this.flightStatusWidgetForm.controls.flightNumber.setValue('');
      this.FlightNumberValue.hideFloatingLabel();
    }
    if (this.findDateDifference()) {
      this.resetCalendar();
    }
    this.isSearchByFlightNumber = false;
  }

  onSubmit(): void {
    const data = {
      ...adobeClickEventAnalyticsMocks,
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: ANALYTICS_EVENTS.CLICK,
      click: {
        name: 'flight status:submit',
        type: 'button',
        page_section: HEADER_MENU.FLIGHT_STATUS.PAGE_SECTION,
        action: this.flightSubmitUrl || ''
      }
    };

    this.adobeDataLayer.setUserDataInAnalytics(data);

    this.iropSubscribe = this.iropService
      .getContent()
      .pipe(
        catchError((error) => {
          this.loggingService.log('IROP service error: ' + error);
          return of(null);
        })
      )
      .subscribe((irop: Irop) => {
        if (irop && irop.iropType) {
          this.getFlightDate();
          const flightNumber =
            this.flightStatusWidgetForm?.controls?.flightNumber.value;
          this.formUrl = `${this.getFlightStatusUrl()}${
            flightNumber ? flightNumber : 0
          }/${this.flightDate}/w`;
          window.location.href = `${this.formUrl}?alerts=irop-error`;
        } else {
          this.onSubmitHandler();
        }
      });
  }

  onSubmitHandler(): void {
    if (this.flightStatusWidgetForm.valid) {
      this.navigateToFlightStatus();
    } else {
      this.isSubmitted = true;
      this.errorPresent.emit(true);
      this.errorHandler.validateForm(true);
    }
  }

  setTrackingObj(e) {
    this.datalayer.setTrackingObjectProp1(
      'header:flight status:arrow',
      e.target
    );
  }

  getFormatedDate(dd, mm, yyyy, format) {
    if (dd.toString().length < 2) {
      dd = '0' + dd;
    }
    if (mm.toString().length < 2) {
      mm = '0' + mm;
    }
    if (format === 'mm/dd/yyyy') {
      return mm + '/' + dd + '/' + yyyy;
    } else {
      return;
    }
  }

  findDateDifference() {
    // get current date in format (mm/dd/yyyy)
    let callReset = false;
    let dateLimit = new Date();
    const format = 'mm/dd/yyyy';
    const dateLimitStringFormat = this.getFormatedDate(
      dateLimit.getDate(),
      dateLimit.getMonth() + 1,
      dateLimit.getFullYear(),
      format
    );
    dateLimit = new Date(dateLimitStringFormat);
    dateLimit.setDate(dateLimit.getDate() - 2);
    // get selected date in format (mm/dd/yyyy)
    let selectedDate = this.flightStatusWidgetForm.controls.departureDate.value;
    if (selectedDate !== '') {
      selectedDate = new Date(selectedDate);
      callReset = dateLimit.getTime() === selectedDate.getTime();
    }
    return callReset;
  }

  navigateToFlightStatus() {
    if (this.flightStatusWidgetForm.controls.departureDate.value) {
      this.getFlightDate();
    }
    if (this.flightStatusWidgetForm.controls.flightNumber.value) {
      const flightNumber =
        this.flightStatusWidgetForm.controls.flightNumber.value;
      this.searchOptionValue = 'FLIGHTNUMBER';
      this.fromAirport = '';
      this.toAirport = '';
      if (this.flightSubmitUrl) {
        this.formUrl =
          this.getFlightStatusUrl() +
          flightNumber +
          '/' +
          this.flightDate +
          '/w';
      } else if (
        !this.flightSubmitUrl &&
        this.config.get('APP_OLD_FLIGHT_STATUS') === 'true'
      ) {
        this.formUrl =
          this.config.get('APP_OLD_URL') +
          this.config.get('APP_OLD_FLIGHT_STATUS_NUM_URL') +
          '=' +
          flightNumber +
          '&flightDate=' +
          this.flightDate;
      } else {
        this.formUrl =
          '/content/www/en_US/#/flightstatus/1/' +
          flightNumber +
          '/' +
          this.flightDate +
          '/w';
      }
      window.location.href = this.formUrl;
    } else if (this.fromAirport && this.toAirport) {
      this.searchOptionValue = 'CITYPAIR';
      this.flightNumber = '';
      if (this.flightSubmitUrl) {
        this.formUrl =
          this.getFlightScheduleUrl() +
          this.fromAirport +
          '/' +
          this.toAirport +
          '/' +
          this.flightDate;
      } else if (
        !this.flightSubmitUrl &&
        this.config.get('APP_OLD_FLIGHT_STATUS') === 'true'
      ) {
        this.formUrl =
          this.config.get('APP_OLD_URL') +
          this.config.get('APP_OLD_FLIGHT_STATUS_CODE_URL') +
          '=' +
          this.fromAirport +
          '&arrivalAirportCode=' +
          this.toAirport +
          '&flightNumber=&flightNumberField=&flightDate=' +
          this.flightDate;
      } else {
        this.formUrl =
          '/content/www/en_US/#/flightschedule/' +
          this.fromAirport +
          '/' +
          this.toAirport +
          '/' +
          this.flightDate;
      }
      window.location.href = this.formUrl;
    }
  }

  getFlightStatusUrl(): string {
    const flightstatusUrl =
      this.flightStatusSubmitUrl === undefined
        ? this.flightSubmitUrl + 'flightstatus/1/'
        : this.flightStatusSubmitUrl;
    return flightstatusUrl;
  }

  getFlightDate(): void {
    const selectedFlightDate = new Date(
      this.flightStatusWidgetForm.controls.departureDate.value
    );
    const selectedYear = selectedFlightDate.getFullYear().toString();
    const selectedMonth = ('0' + (selectedFlightDate.getMonth() + 1))
      .slice(-2)
      .toString();
    const selectedDate = ('0' + selectedFlightDate.getDate())
      .slice(-2)
      .toString();
    this.flightDate = selectedYear + '-' + selectedMonth + '-' + selectedDate;
  }

  getFlightScheduleUrl() {
    const flightschedule =
      this.flightScheduleSubmitUrl === undefined
        ? this.flightSubmitUrl + 'flightschedule/'
        : this.flightScheduleSubmitUrl;
    return flightschedule;
  }

  onFocusOutFromAirport() {
    if (this.fromAirport === this.toAirport) {
      this.fieldToFocus = 'departcitylink';
    } else {
      if (
        this.toAirport === undefined ||
        this.toAirport === null ||
        this.toAirport === ''
      ) {
        this.fieldToFocus = 'arrivalcitylink';
      } else {
        this.fieldToFocus = 'departcitylink';
      }
    }
  }

  onFocusOutToAirport() {
    if (this.fromAirport === this.toAirport) {
      this.fieldToFocus = 'arrivalcitylink';
    } else {
      if (
        this.fromAirport === undefined ||
        this.fromAirport === null ||
        this.fromAirport === ''
      ) {
        this.fieldToFocus = 'departcitylink';
      } else {
        this.fieldToFocus = 'arrivalcitylink';
      }
    }
  }

  ngOnDestroy() {
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    if (this.iropSubscribe) {
      this.iropSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.cdf.detach();
  }

  resetCalendar() {
    if (this.flightSearchStartDate) {
      // When called, it will reset the calender irrespective whether its a DL or VS Flow
      this.dateSelComp.resetCalendar();
    }
  }
}
